import { render, staticRenderFns } from "./PesquisaConfianteCelular.vue?vue&type=template&id=1c2b6398&scoped=true"
import script from "./PesquisaConfianteCelular.vue?vue&type=script&lang=js"
export * from "./PesquisaConfianteCelular.vue?vue&type=script&lang=js"
import style0 from "./PesquisaConfianteCelular.vue?vue&type=style&index=0&id=1c2b6398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2b6398",
  null
  
)

export default component.exports